var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChaxun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6679 14.0995L14.6676 14.0992L12.6484 12.0963C13.7731 10.7646 14.3413 9.05029 14.2341 7.30996C14.1265 5.56216 13.3461 3.92399 12.0567 2.73919C10.7672 1.55438 9.06904 0.915049 7.3184 0.955341C5.56775 0.995634 3.90076 1.71242 2.66721 2.95529C1.43366 4.19816 0.72945 5.8705 0.70234 7.6214C0.67523 9.3723 1.32733 11.0656 2.52181 12.3461C3.71629 13.6266 5.36029 14.3946 7.10885 14.4891C8.8497 14.5831 10.5595 14.0023 11.8825 12.8679L13.9012 14.8714L13.9015 14.8717C14.0045 14.9704 14.1421 15.0247 14.2847 15.023C14.4274 15.0212 14.5636 14.9635 14.6641 14.8622C14.7646 14.7609 14.8213 14.6243 14.822 14.4816C14.8227 14.339 14.7674 14.2018 14.6679 14.0995ZM11.509 11.7308C10.447 12.8009 9.00336 13.4052 7.49572 13.4109C5.98808 13.4166 4.53994 12.8231 3.46986 11.7611C2.39979 10.699 1.79544 9.25537 1.78976 7.74774C1.78408 6.2401 2.37755 4.79195 3.4396 3.72188C4.50164 2.65181 5.94528 2.04746 7.45292 2.04178C8.96055 2.0361 10.4087 2.62957 11.4788 3.69161C12.5488 4.75366 13.1532 6.1973 13.1589 7.70493C13.1645 9.21257 12.5711 10.6607 11.509 11.7308Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.05
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaxun);
export default __webpack_public_path__ + "static/media/chaxun.2283e888ac3739ba69ad34e68812ac3a.svg";
export { ForwardRef as ReactComponent };